import type { CustomerRow } from "@/types/api";

export function formatCustomerDisplayName(c: {
  name: string | null;
  email: string | null;
}): string {
  return c.name?.trim() || c.email?.trim() || "Unknown customer";
}

export function formatCustomerOptionLabel(c: CustomerRow): string {
  const label = formatCustomerDisplayName(c);
  return `${label} (${c.id})`;
}

export function customerNameForId(
  customerId: string | null | undefined,
  customers: CustomerRow[],
): string {
  if (!customerId) return "—";
  const row = customers.find((c) => c.id === customerId);
  if (!row) return customerId;
  return formatCustomerDisplayName(row);
}

export function customerEmailForId(
  customerId: string | null | undefined,
  customers: CustomerRow[],
): string | null {
  if (!customerId) return null;
  const row = customers.find((c) => c.id === customerId);
  return row?.email?.trim() || null;
}

/** Prefer Stripe row fields from search API; fall back to loaded customer list. */
export function resolveCustomerName(
  row: { customer_id?: string | null; customer_name?: string | null },
  customers: CustomerRow[],
): string {
  const fromRow = row.customer_name?.trim();
  if (fromRow) return fromRow;
  return customerNameForId(row.customer_id, customers);
}

/** Prefer Stripe row fields from search API; fall back to loaded customer list. */
export function resolveCustomerEmail(
  row: { customer_id?: string | null; customer_email?: string | null },
  customers: CustomerRow[],
): string | null {
  const fromRow = row.customer_email?.trim();
  if (fromRow) return fromRow;
  return customerEmailForId(row.customer_id, customers);
}
